import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerPageComponent } from './partner-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartnerPageRoutingModule } from './partner-page-routing.module';
import { HomebannerModule } from '../shared/components/homebanner/homebanner.module';
import { PageBannerModule } from '../shared/components/page-banner/page-banner.module';



@NgModule({
  declarations: [PartnerPageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PartnerPageRoutingModule,
    HomebannerModule,
    PageBannerModule
  ]
})
export class PartnerPageModule { }
